import start from '@/store/modules/interactions/matches/start';
import players from '@/store/modules/interactions/matches/players';

export default {
    players,
    start,
};
